<template>
  <div class="qa-hub-page">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "qa-management-hub",
  mounted() {
    document.documentElement.classList.add("pm-scroll-lock");
  },
  beforeUnmount() {
    document.documentElement.classList.remove("pm-scroll-lock");
  },
};
</script>

<style scoped>
.qa-hub-page {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
